module.exports = __webpack_public_path__ + "static/media/3.cb95ae1b.jpg";